/**
 * @file OperationsControlPanelPage.jsx
 * @description OPERATIONS department — Control Panel.
 *
 * The live fleet panel until Operations gets a dashboard of its own.
 *
 * This file belongs to the OPERATIONS department. Departments never share page
 * files: each department's top-bar header mounts its OWN file (this one), so
 * a change for OPERATIONS is made HERE and can never leak into another
 * department's screens. The shared engine underneath (ControlPanelPage) and the backend
 * stay common — only the department-facing page is departmental. Route access
 * is department-gated in utils/permissions.js: only OPERATIONS users (and the
 * super admin) can open it.
 */
import React from 'react';
import { FleetControlPanel } from '../ControlPanelPage';

const OperationsControlPanelPage = () => (<FleetControlPanel />);

export default OperationsControlPanelPage;
